import { render, staticRenderFns } from "./AIMList.vue?vue&type=template&id=f85c6040&"
import script from "./AIMList.vue?vue&type=script&lang=js&"
export * from "./AIMList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports